module.exports = __webpack_public_path__ + "static/media/herdy-notification.9f9bbadc.svg";